<template>
  <div class="wrapper">
    <div class="background"  v-bind:style="{ backgroundImage: `url('${src}')`}" />
    <img v-if="src && vImgEnabled" :src="src" v-img="{title: title, group: group, opened, closed}" />
  </div>
</template>

<script>
import disableScroll from 'disable-scroll';

export default {
  name: 'ImageView',
  props: ['src', 'title', 'group', 'vImgEnabled'],
  methods: {
    opened() {
      disableScroll.on();
    },
    closed() {
      disableScroll.off();
    },
  },
};
</script>

<style lang="sass" scoped>

  .wrapper
    position: relative
    overflow: hidden

    .background
      background-size: cover
      background-position: center
      position: absolute
      top: 0
      left: 0
      right: 0
      bottom: 0

    img
      opacity: 0
      position: absolute
      top: 0
      left: 0
      right: 0
      bottom: 0

</style>



// WEBPACK FOOTER //
// src/components/ImageView.vue